import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo } from 'react';

import { PartnerItemType } from '../../../api/types';
import { useConfig } from '../../../context/config-provider';
import { FooterLicense } from '../footer-license/footer-license';

import { FooterPartner } from './footer-partner';

import './footer-partners.scss';

export function FooterPartnersListUI({ className, partners, isWithLicense }) {
  if (partners?.length === 0 || !partners) {
    return null;
  }

  return (
    <div className={clsx('sb-FooterPartners', className)}>
      {isWithLicense && <FooterLicense />}
      {partners.map(partner => (
        <FooterPartner key={partner.logo.url} className="sb-FooterPartners-item" partner={partner} />
      ))}
    </div>
  );
}

FooterPartnersListUI.propTypes = {
  className: PropTypes.string,
  partners: PropTypes.arrayOf(PartnerItemType),
  isWithLicense: PropTypes.bool,
};

FooterPartnersListUI.defaultProps = {
  className: undefined,
  partners: [],
  isWithLicense: false,
};

export const FooterPartnersList = memo(FooterPartnersListUI);

function FooterPartnersUI() {
  const { footer } = useConfig();

  // eslint-disable-next-line react/no-array-index-key
  return footer?.partners?.map(({ items }, index) => <FooterPartnersList key={index} partners={items} />);
}

export const FooterPartners = memo(FooterPartnersUI);
